export default {
  banners: null,
  banner: null,
  error: false,
  errorMessage: "",
  success: false,
  successMessage: "",
};
